import { ProductECourseItemErrorsType } from '../../../types/product-interface'

export const defaultErrors: ProductECourseItemErrorsType = {
  title: '',
  subTitle: '',
  buttonTitle: '',
  thumbnail: '',
  ['checkoutPage.title']: '',
  ['checkoutPage.buttonTitle']: '',
  ['checkoutPage.description']: '',
  ['checkoutPage.fields']: '',
  ['checkoutPage.coverId']: '',
  ['thankYouPage.title']: '',
  ['thankYouPage.text']: '',
  ['digitalStore.paymentMethods']: '',
  ['digitalProduct.pricePlans']: '',
  ['digitalProduct.resources']: '',
  ['courseId']: '',
}
